import { useTable, useFlexLayout } from 'react-table';
import * as _ from 'lodash';
import { TemplateTypeInConfig }  from './CommonTable.d';
import { useSticky } from 'react-table-sticky';
import { useState } from 'react';

const PLACE_HOLDER = '-';

const getDefaultTemplate = (value, spanClass) => {
  return (
    <div>
      {
        (value !== PLACE_HOLDER) && (<span className={spanClass}>{value}</span>)
      } 
      {
        (value === PLACE_HOLDER) && (<span>{value}</span>)
      }
    </div>
  )
}

const getMultiStyleTextIconTemplate = (value) => {
  return (
    <div style={{display: "inline-flex"}}>
      {
        (value.prefixIconClass) && (
          getDefaultTemplate('', value.prefixIconClass)
        )
      }
      {
        (value.prefixValue) && (
          getDefaultTemplate(value.prefixValue, value.prefixClass)
        )
      }
      {
        getDefaultTemplate(value.value, value.style)
      }
      {
        (value.suffixIconClass) && (
          getDefaultTemplate('', value.suffixIconClass)
        )
      }
      {
        (value.suffixValue) && (
          getDefaultTemplate(value.suffixValue, value.suffixClass)
        )
      }
    </div>
  )
}

const getFractionTemplate = (value) => {
  return (
    <div>
      {
        (value.isValidFraction) && (
          <div style={{display: "inline-flex"}}>
            {
              getDefaultTemplate(value.numerator, value.numStyle)
            }
            <span>/</span>
            {
              getDefaultTemplate(value.denominator, value.denStyle) 
            }
          </div>
        )
      }
      {
        (!value.isValidFraction) && (<span> {{PLACE_HOLDER}}</span>)
      }
    </div>
  )
}

const headerTemplate = (headerObject) => {
  if (typeof(headerObject.column.Header) === 'object') {
    return getTemplate(headerObject.column.headerData, headerObject.column.headerTemplateType);
  } else {
    return (<span>{headerObject.column.Header}</span>)
  }
}

const getTemplate = (value, cellTemplateType: TemplateTypeInConfig) => {
  switch (cellTemplateType) {
    case TemplateTypeInConfig.MultiStyleTextIcon: return getMultiStyleTextIconTemplate(value)
    case TemplateTypeInConfig.Fraction: return getFractionTemplate(value)
    default: return getDefaultTemplate(value?.value, value?.style)
  }
}

const cellRenderFunc = (cell) => {
    if (typeof(cell.value) === 'object') {
      return getTemplate(cell.value, cell.column.cellTemplateType)
    } else {
      return (<span>{cell.value}</span>)
    }
}

const summaryFunc = (header) => {
  const column = header.column;

  return (
    <div>
      {getTemplate(column.summaryData, column.summaryTemplateType)}
    </div>
  )
}


  const CommonTable = (props) => {

    const data = props.config.rows;
    const columns = props.config.columns;
    const columnMode = props.config.columnMode;
    const height = props.config.height;

    const [noDataFlag, setNoDataFlag] = useState(props.config.rows.length === 0);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        //footerGroups,
        rows,
        prepareRow,
      } = useTable({ columns, data }, useFlexLayout, useSticky)

      // Workaround as react-table footerGroups doesn't provide the same internal data than headerGroups
      const footerGroups = headerGroups.slice().reverse();

      return (
        <div className="common-table" style={{maxWidth: '100%', overflowX: 'auto', height: height}}>
            <table {...getTableProps()} style={{ width: '100%' }}>
              <thead className="header">
                  {headerGroups.map(headerGroup => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map(headerObject => (
                        <th
                          {...headerObject.getHeaderProps({
                            style: {
                              flexGrow: headerObject.flexGrow,
                              flexShrink: headerObject.flexGrow
                            }
                          })}
                          className={(headerObject.isGroupHeader) ? headerObject.groupHeaderClass : headerObject.headerClasses}
                        >
                          {headerObject.render(headerTemplate)}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                {
                  (noDataFlag) && (
                    <tbody className="body">
                        <tr><td><div className="empty-message">NO DATA</div></td></tr>
                    </tbody>

                  )
                }
                {
                  (!noDataFlag) && (
                    <>
                      <tbody {...getTableBodyProps()} className="body">
                        {rows.map(row => {
                          prepareRow(row)
                          return (
                            <tr {...row.getRowProps()}>
                              {row.cells.map(cell => {
                                return (
                                  <td
                                    {...cell.getCellProps({
                                      style: {
                                        padding: '0px',
                                        flexGrow: cell.column.flexGrow,
                                        flexShrink: cell.column.flexGrow
                                      }
                                    })}
                                  >
                                      <div className={cell.column.cellClasses}>
                                          {cell.render(cellRenderFunc)}
                                      </div>
                                  </td>
                                )
                              })}
                            </tr>
                          )
                        })}
                      </tbody>
  
                      <tfoot>
                        {footerGroups.map(group => (
                          <tr {...group.getHeaderGroupProps()}>
                            {group.headers.map(header => (
                              <td {...header.getHeaderProps({
                                style: {
                                  flexGrow: header.flexGrow,
                                  flexShrink: header.flexGrow
                                }
                              })} className={header.summaryClass}>
                                  {header.render(summaryFunc)}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tfoot>
                    </>
                  )
                }
            </table>
        </div>
      )

      // if (noDataFlag) {
      //   return (
      //     <div className="common-table" style={{maxWidth: '100%', overflowX: 'auto', height: height}}>
      //       <table {...getTableProps()} style={{ width: '100%' }} >
      //         <thead className="header">
      //           {headerGroups.map(headerGroup => (
      //             <tr {...headerGroup.getHeaderGroupProps()}>
      //               {headerGroup.headers.map(headerObject => (
      //                 <th
      //                   {...headerObject.getHeaderProps({
      //                     style: {
      //                       flexGrow: headerObject.flexGrow,
      //                       flexShrink: headerObject.flexGrow
      //                     }
      //                   })}
      //                   className={(headerObject.isGroupHeader) ? headerObject.groupHeaderClass : headerObject.headerClasses}
      //                 >
      //                   {headerObject.render(headerTemplate)}
      //                 </th>
      //               ))}
      //             </tr>
      //           ))}
      //         </thead>
      //           <tbody >
      //           <tr><td><div className="empty-message">NO DATA</div></td></tr>
      //           </tbody>
      //       </table>
      //   </div>
      //   )
      // } else {
      //   return (
      //     <div className="common-table" style={{maxWidth: '100%', overflowX: 'auto', height: height}}>
      //     <table {...getTableProps()} style={{ width: '100%' }} >
      //       <thead className="header">
      //         {headerGroups.map(headerGroup => (
      //           <tr {...headerGroup.getHeaderGroupProps()}>
      //             {headerGroup.headers.map(headerObject => (
      //               <th
      //                 {...headerObject.getHeaderProps({
      //                   style: {
      //                     flexGrow: headerObject.flexGrow,
      //                     flexShrink: headerObject.flexGrow
      //                   }
      //                 })}
      //                 className={(headerObject.isGroupHeader) ? headerObject.groupHeaderClass : headerObject.headerClasses}
      //               >
      //                 {headerObject.render(headerTemplate)}
      //               </th>
      //             ))}
      //           </tr>
      //         ))}
      //       </thead>
      //           <tbody {...getTableBodyProps()} className="body">
      //             {rows.map(row => {
      //               prepareRow(row)
      //               return (
      //                 <tr {...row.getRowProps()}>
      //                   {row.cells.map(cell => {
      //                     return (
      //                       <td
      //                         {...cell.getCellProps({
      //                           style: {
      //                             padding: '0px',
      //                             flexGrow: cell.column.flexGrow,
      //                             flexShrink: cell.column.flexGrow
      //                           }
      //                         })}
      //                       >
      //                           <div className={cell.column.cellClasses}>
      //                               {cell.render(cellRenderFunc)}
      //                           </div>
      //                       </td>
      //                     )
      //                   })}
      //                 </tr>
      //               )
      //             })}
      //           </tbody>
  
      //           <tfoot>
      //             {footerGroups.map(group => (
      //               <tr {...group.getHeaderGroupProps()}>
      //                 {group.headers.map(header => (
      //                   <td {...header.getHeaderProps({
      //                     style: {
      //                       flexGrow: header.flexGrow,
      //                       flexShrink: header.flexGrow
      //                     }
      //                   })} className={header.summaryClass}>
      //                       {header.render(summaryFunc)}
      //                   </td>
      //                 ))}
      //               </tr>
      //             ))}
      //           </tfoot>
      //     </table>
      //     </div>
      //   )
      // }
  }

  export default CommonTable;